import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Row, Button, Spinner, Modal, ModalHeader } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import { getRandomPlace } from '../features/place/placeSlice';
import ItemExplainer from './ItemExplainer';
import { useSpeechSynthesis } from 'react-speech-kit';
import NewThingForm from './NewThingForm';
import { createPlace } from '../features/place/placeSlice';
import { toast } from 'react-toastify';

function Place() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); // State to manage modal visibility

  const place = useSelector((state) => state.place.place);
  const userCreator = useSelector((state) => state.place.user);
  const user = useSelector((state) => state.auth.user)

  const handleGetRandomPlace = async () => {
    setLoading(true);
    try {
      await dispatch(getRandomPlace());
    } catch (error) {
      console.error('Error fetching random place:', error);
    } finally {
      setLoading(false);
    }
  };

  const { speak } = useSpeechSynthesis();

  const handlePlayback = (text) => {
    try {
      console.log(`Trying to say ${text}`);
      speak({ text });
    } catch (error) {
      console.error('Error during speech synthesis:', error);
    }
  };

  const handleClipboard = () => {
    const itemToCopy = place.name;
    if (!itemToCopy) {
      return;
    }
    navigator.clipboard.writeText(itemToCopy).then(
      function () {
        alert(`Copied ${itemToCopy} to clipboard`);
      })
      .catch(
        function () {
          alert("Error copying to clipboard!");
        });
  };

  const toggleModal = () => setShowModal(!showModal); // Function to toggle modal visibility

  const handleFormSubmit = async (formData) => {
    // Handle form submission
    try {
      // Dispatch action to create a new place
      await dispatch(createPlace(formData));
      // Close the modal after successful submission
      setShowModal(false);
      toast.success(`Success: ${formData.incomingName} added`);
    } catch (error) {
      if (error.response && error.response.status === 409) {
        toast.error('A place with the same name already exists.');
      } else {
        console.error('Error submitting form:', error);
        toast.error('An error occurred while submitting the form. Please try again later.');
      }
    }
  };

  return (
    <>
      <Col className="bordered d-grid gap-2">
        <Row className="itemTitle">
          <h2>Places!</h2>
        </Row>
        <Row className="randomPlace">
          <Button onClick={handleGetRandomPlace} disabled={loading} size="lg">
            {loading ?
              <>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                {'Loading...'} </>
              : 'Get Random Place'}
          </Button>
        </Row>
        <Row className="display">
          {place && (
            <Button
              variant="info"
            >
              <div>
                <ItemExplainer item={place} user={userCreator} handlePlayback={handlePlayback} handleClipboard={handleClipboard} />
              </div>
            </Button>
          )}
        </Row>
        <hr />
        <Row>
          <Col>
            {user ? (
              <>
                <Button onClick={toggleModal}>Add your own</Button>
                <Modal show={showModal} onHide={toggleModal}> {/* Modal component with show and onHide props */}
                  <Modal.Header closeButton>
                    <Modal.Title>Add New Place</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <NewThingForm userId={user._id} onSubmit={handleFormSubmit} closeModal={toggleModal} />
                  </Modal.Body>
                </Modal>
              </>
            ) : (
              <>
              </>
            )}
          </Col>
        </Row>
      </Col>
    </>
  );
}

export default Place;
